import type { EmailOtpType } from "@supabase/supabase-js";

const EMAIL_OTP_TYPES: readonly EmailOtpType[] = [
  "magiclink",
  "signup",
  "invite",
  "recovery",
  "email_change",
  "email",
];

/**
 * The token hash an email login link carries (see magicLoginLink in the edge
 * functions), as verifyOtp params, or null when the URL has none.
 */
export function readTokenHashLogin(url: URL): { token_hash: string; type: EmailOtpType } | null {
  const tokenHash = url.searchParams.get("token_hash");
  const type = url.searchParams.get("type") as EmailOtpType | null;
  if (!tokenHash || !type || !EMAIL_OTP_TYPES.includes(type)) return null;
  return { token_hash: tokenHash, type };
}
